class VorixiaAmazonGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.image = gallery.querySelector('.vorixia-amazon-gallery__main-image');
    this.main = gallery.querySelector('.vorixia-amazon-gallery__main');
    this.thumbs = Array.from(gallery.querySelectorAll('[data-vorixia-gallery-thumb]'));
    this.productInfo = gallery.closest('product-info') || document;
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.swipePointerId = null;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.select(thumb));
      thumb.addEventListener('mouseenter', () => this.select(thumb));
      thumb.addEventListener('focus', () => this.select(thumb));
    });

    this.productInfo.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || !this.isColorControl(target)) return;
      this.syncToColor(target.value);
    });

    this.bindSwipe();
    this.syncToColor(this.currentColor(), { keepCurrent: true });
  }

  select(thumb) {
    if (thumb.classList.contains('is-hidden')) return;
    if (!this.image || !thumb.dataset.fullSrc) return;

    this.image.src = thumb.dataset.fullSrc;
    this.image.srcset = '';
    this.image.alt = thumb.dataset.alt || '';

    this.thumbs.forEach((item) => {
      item.classList.toggle('is-active', item === thumb);
      if (item === thumb) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }

  syncToColor(color, options = {}) {
    if (!color) return;

    let firstVisibleThumb = null;
    let activeStillVisible = false;

    this.thumbs.forEach((thumb) => {
      const matches = thumb.dataset.color === color;
      thumb.classList.toggle('is-hidden', !matches);
      thumb.toggleAttribute('hidden', !matches);

      if (matches && !firstVisibleThumb) firstVisibleThumb = thumb;
      if (matches && thumb.classList.contains('is-active')) activeStillVisible = true;
    });

    if (!options.keepCurrent || !activeStillVisible) {
      this.select(firstVisibleThumb);
    }
  }

  visibleThumbs() {
    return this.thumbs.filter((thumb) => !thumb.classList.contains('is-hidden') && !thumb.hidden);
  }

  activeIndex() {
    const visibleThumbs = this.visibleThumbs();
    const activeThumb = visibleThumbs.find((thumb) => thumb.classList.contains('is-active'));
    return Math.max(0, visibleThumbs.indexOf(activeThumb));
  }

  go(direction) {
    const visibleThumbs = this.visibleThumbs();
    if (visibleThumbs.length < 2) return;

    const nextIndex = (this.activeIndex() + direction + visibleThumbs.length) % visibleThumbs.length;
    this.select(visibleThumbs[nextIndex]);
  }

  bindSwipe() {
    if (!this.main) return;

    this.main.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      this.swipeStartX = event.clientX;
      this.swipeStartY = event.clientY;
      this.swipePointerId = event.pointerId;
    });

    this.main.addEventListener('pointerup', (event) => {
      if (this.swipePointerId !== event.pointerId) return;

      const deltaX = event.clientX - this.swipeStartX;
      const deltaY = event.clientY - this.swipeStartY;
      this.swipePointerId = null;

      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
      this.go(deltaX < 0 ? 1 : -1);
    });

    this.main.addEventListener('pointercancel', () => {
      this.swipePointerId = null;
    });
  }

  currentColor() {
    const checkedColor = Array.from(this.productInfo.querySelectorAll('input[type="radio"]:checked')).find((input) =>
      this.isColorControl(input),
    );
    if (checkedColor) return checkedColor.value;

    const selectedColor = Array.from(this.productInfo.querySelectorAll('select')).find((select) => this.isColorControl(select));
    return selectedColor ? selectedColor.value : this.gallery.dataset.activeColor;
  }

  isColorControl(control) {
    const name = `${control.name || ''} ${control.id || ''}`.toLowerCase();
    const fieldset = control.closest('fieldset');
    const legend = fieldset ? fieldset.querySelector('legend')?.textContent?.toLowerCase() : '';
    const label = control.labels && control.labels[0] ? control.labels[0].textContent.toLowerCase() : '';

    return name.includes('color') || legend.includes('color') || label.includes('color');
  }
}

document.querySelectorAll('[data-vorixia-gallery]').forEach((gallery) => {
  new VorixiaAmazonGallery(gallery);
});
